import { Box, styled } from '@mui/material';

export const EditVariationTemplatePageWrapper = styled(Box)`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: unset !important;
  padding-right: unset !important;
`;
